"use client";

import { Collapsible as CollapsiblePrimitive } from "@base-ui/react/collapsible";
import { ChevronDownIcon } from "lucide-react";

import { cx } from "../../cx";
import styles from "./collapsible.module.css";

type WithClassName<P> = Omit<P, "className"> & { className?: string };

function Collapsible({
  className,
  ...props
}: WithClassName<CollapsiblePrimitive.Root.Props>) {
  return (
    <CollapsiblePrimitive.Root
      data-slot="collapsible"
      className={className}
      {...props}
    />
  );
}

/** `chevron` ends the trigger in a chevron that turns while the panel is
 *  open; a page restyles it through `[data-slot="collapsible-chevron"]`. */
function CollapsibleTrigger({
  className,
  chevron = false,
  children,
  ...props
}: WithClassName<CollapsiblePrimitive.Trigger.Props> & { chevron?: boolean }) {
  return (
    <CollapsiblePrimitive.Trigger
      data-tui=""
      data-slot="collapsible-trigger"
      className={cx(styles.trigger, className)}
      {...props}
    >
      {children}
      {chevron ? (
        <ChevronDownIcon
          aria-hidden
          data-slot="collapsible-chevron"
          className={styles.chevron}
          strokeWidth={2}
        />
      ) : null}
    </CollapsiblePrimitive.Trigger>
  );
}

function CollapsiblePanel({
  className,
  ...props
}: WithClassName<CollapsiblePrimitive.Panel.Props>) {
  return (
    <CollapsiblePrimitive.Panel
      data-tui=""
      data-slot="collapsible-panel"
      className={cx(styles.panel, className)}
      {...props}
    />
  );
}

export { Collapsible, CollapsiblePanel, CollapsibleTrigger };
